import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { RequestService } from '../../../services/Request/RequestService'
import { RequestNoteService } from '../../../services/Request/RequestNoteService'

export interface IRequestNoteDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  request: any
  onDelete: () => void
  leastDestructiveRef: any
}

export function RequestNoteDeleteDialog({
  isOpen,
  onClose,
  request,
  onDelete,
  leastDestructiveRef
}: IRequestNoteDeleteDialogProps) {
  const requestNoteService = new RequestNoteService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await requestNoteService.destroy(request.id)

      toast({
        title: 'Observação deletada',
        description: 'Observação deletada com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onDelete()
      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao deletar observação',
        description: 'Erro ao deletar observação, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Deletar observação
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja deletar a observação?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Deletar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
